(function () {
    'use strict';

    angular.module("imApp").factory("salaryTypesService", [function () {
        let service = {};

        return service;
    }]);
})();
